export const data = [
  //1
  {
    key: "c4-01",
    title: "이것은 뭐야?",
    grade: "1권",
    cover: require("@data/assets/green/book1/images/cover.jpg"),
    background: require("@data/assets/green/book1/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book1/sounds/page23.mp3"),
      title: "Zhè shì shénme?",
      caption: [
        "zhè zhè zhè zhè shì shénme zhè shì diànnǎo",
        "zhè shì shénme zhè shì kōngtiáo",
        "zhè shì shénme zhè shì shùmǎ xiàngjī",
        "zhè shì shénme diànnǎo kōngtiáo shùmǎ xiàngjī",
        "nà nà nà nà shì shénme nà shì diànhuà",
        "nà shì shénme nà shì diànshì",
        "nà shì shénme nà shì bīngxiāng",
        "nà shì shénme diànhuà diànshì bīngxiāng",
      ],
    },
    mov: {
      cn: "04e3300672cd5bb8fecf8a8e936f9b9f_01",
      en: "8ffea93a6acc38e57c7e27cae5492d98_01",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book1/images/img_G1-03.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_01.mp3"),
          word: "电脑|diànnǎo",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-02.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_02.mp3"),
          word: "冰箱|bīngxiāng",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-01.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_03.mp3"),
          word: "空调|kōngtiáo",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-06.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_04.mp3"),
          word: "数码相机|shùmǎ xiàngjī",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-05.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_05.mp3"),
          word: "电话|diànhuà",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-04.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_06.mp3"),
          word: "电视|diànshì",
        },
        //

        {
          img: require("@data/assets/green/book1/images/img_G1-12.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_07.mp3"),
          word: "这是什么？|Zhè shì shénme?",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-07.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_08.mp3"),
          word: "那是什么？|Nà shì shénme?",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-10.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_09.mp3"),
          word: "这是电脑。|Zhè shì diànnǎo.",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-09.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_10.mp3"),
          word: "那是冰箱。|Nà shì bīngxiāng.",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-12.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_11.mp3"),
          word: "这是空调。|Zhè shì kōngtiáo.",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-11.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_12.mp3"),
          word: "这是数码相机。|Zhè shì shùmǎ xiàngjī.",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-14.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_13.mp3"),
          word: "这是电话。|Zhè shì diànhuà.",
        },
        {
          img: require("@data/assets/green/book1/images/img_G1-13.png"),
          sound: require("@data/assets/green/book1/sounds/KD01_W_14.mp3"),
          word: "那是电视。|Nà shì diànshì.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book1/images/img_G1-03.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_01.mp3"),
        buttons: [{ ch2: "diànnǎo" }, { ch: "电脑" }, { ko: "컴퓨터" }],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-02.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_02.mp3"),
        buttons: [{ ch2: "bīngxiāng" }, { ch: "冰箱" }, { ko: "냉장고" }],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-01.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_03.mp3"),
        buttons: [{ ch2: "kōngtiáo" }, { ch: "空调" }, { ko: "에어컨" }],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-06.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_04.mp3"),
        buttons: [
          { ch2: "shùmǎ xiàngjī" },
          { ch: "数码相机" },
          { ko: "디지털 카메라" },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-05.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_05.mp3"),
        buttons: [{ ch2: "diànhuà" }, { ch: "电话" }, { ko: "전화" }],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-04.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_06.mp3"),
        buttons: [{ ch2: "diànshì" }, { ch: "电视" }, { ko: "텔레비전" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book1/images/img_G1-12.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_07.mp3"),
        buttons: [
          { ch2: "Zhè shì shénme?" },
          { ch: "这是什么？" },
          { ko: "이것은 뭐예요?" },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-07.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_08.mp3"),
        buttons: [
          { ch2: "Nà shì shénme?" },
          { ch: "那是什么？" },
          { ko: "저것은 뭐예요?" },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-10.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_09.mp3"),
        buttons: [
          { ch2: "Zhè shì diànnǎo." },
          { ch: "这是电脑。" },
          { ko: "이것은 컴퓨터예요." },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-09.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_10.mp3"),
        buttons: [
          { ch2: "Nà shì bīngxiāng." },
          { ch: "那是冰箱。" },
          { ko: "저것은 냉장고예요." },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-12.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_11.mp3"),
        buttons: [
          { ch2: "Zhè shì kōngtiáo." },
          { ch: "这是空调。" },
          { ko: "이것은 에어컨이에요." },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-11.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_12.mp3"),
        buttons: [
          { ch2: "Zhè shì shùmǎ xiàngjī." },
          { ch: "这是数码相机。" },
          { ko: "이것은 디지털 카메라예요." },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-14.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_13.mp3"),
        buttons: [
          { ch2: "Zhè shì diànhuà." },
          { ch: "这是电话。" },
          { ko: "이것은 전화예요." },
        ],
      },
      {
        img: require("@data/assets/green/book1/images/img_G1-13.png"),
        sound: require("@data/assets/green/book1/sounds/KD01_W_14.mp3"),
        buttons: [
          { ch2: "Nà shì diànshì." },
          { ch: "那是电视。" },
          { ko: "저것은 텔레비전이에요." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book1/sounds/KD01_W_01.mp3"),
          img: require("@data/assets/green/book1/images/img_G1-03.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book1/sounds/KD01_W_03.mp3"),
          answer: [
            [require("@data/assets/green/book1/images/img_G1-01.png"), true],
            [require("@data/assets/green/book1/images/img_G1-05.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book1/sounds/KD01_W_02.mp3"),
          answer: [
            ["冰箱", true],
            ["电视", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book1/pages/front.jpg"),
        sound: require("@data/assets/green/book1/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book1/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page04.jpg"),
        sound: require("@data/assets/green/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page06.jpg"),
        sound: require("@data/assets/green/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page08.jpg"),
        sound: require("@data/assets/green/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page10.jpg"),
        sound: require("@data/assets/green/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page12.jpg"),
        sound: require("@data/assets/green/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page14.jpg"),
        sound: require("@data/assets/green/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page16.jpg"),
        sound: require("@data/assets/green/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page18.jpg"),
        sound: require("@data/assets/green/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page20.jpg"),
        sound: require("@data/assets/green/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page22.jpg"),
        sound: require("@data/assets/green/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page23.jpg"),
        sound: require("@data/assets/green/book1/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book1/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book1/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book1/thumbnail/front.jpg"),
      require("@data/assets/green/book1/thumbnail/page02.jpg"),
      require("@data/assets/green/book1/thumbnail/page03.jpg"),
      require("@data/assets/green/book1/thumbnail/page04.jpg"),
      require("@data/assets/green/book1/thumbnail/page05.jpg"),
      require("@data/assets/green/book1/thumbnail/page06.jpg"),
      require("@data/assets/green/book1/thumbnail/page07.jpg"),
      require("@data/assets/green/book1/thumbnail/page08.jpg"),
      require("@data/assets/green/book1/thumbnail/page09.jpg"),
      require("@data/assets/green/book1/thumbnail/page10.jpg"),
      require("@data/assets/green/book1/thumbnail/page11.jpg"),
      require("@data/assets/green/book1/thumbnail/page12.jpg"),
      require("@data/assets/green/book1/thumbnail/page13.jpg"),
      require("@data/assets/green/book1/thumbnail/page14.jpg"),
      require("@data/assets/green/book1/thumbnail/page15.jpg"),
      require("@data/assets/green/book1/thumbnail/page16.jpg"),
      require("@data/assets/green/book1/thumbnail/page17.jpg"),
      require("@data/assets/green/book1/thumbnail/page18.jpg"),
      require("@data/assets/green/book1/thumbnail/page19.jpg"),
      require("@data/assets/green/book1/thumbnail/page20.jpg"),
      require("@data/assets/green/book1/thumbnail/page21.jpg"),
      require("@data/assets/green/book1/thumbnail/page22.jpg"),
      require("@data/assets/green/book1/thumbnail/page23.jpg"),
      require("@data/assets/green/book1/thumbnail/page24.jpg"),
      require("@data/assets/green/book1/thumbnail/page25.jpg"),
      require("@data/assets/green/book1/thumbnail/page26.jpg"),
      require("@data/assets/green/book1/thumbnail/page27.jpg"),
    ],
  },
  //2
  {
    key: "c4-02",
    title: "한입에 꿀꺽",
    grade: "2권",
    cover: require("@data/assets/green/book2/images/cover.jpg"),
    background: require("@data/assets/green/book2/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book2/sounds/page23.mp3"),
      title: "Nǐ chī shénme?",
      caption: [
        "nǐ chī shénme shénme shénme",
        "wǒ chī hànbǎobāo hànbǎobāo",
        "wǒ chī dàngāo dàngāo dàngāo",
        "wǒ chī bīngqílín bīngqílín bīngqílín",
        "nǐ chī shénme shénme shénme",
        "wǒ chī Yìdàlìmiàn Yìdàlìmiàn",
        "wǒ chī bǐnggān bǐnggān bǐnggān",
        "wǒ chī pútao pútao pútao hěn hǎochī",
      ],
    },
    mov: {
      cn: "e9a9a3b2626bac85e3a223779efe2bfa_02",
      en: "fcf77a5492aac0915c49c425aba4f3e8_02",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book2/images/img_G2-04.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_01.mp3"),
          word: "汉堡包|hànbǎobāo",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-05.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_02.mp3"),
          word: "蛋糕|dàngāo",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-06.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_03.mp3"),
          word: "冰淇淋|bīngqílín",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-01.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_04.mp3"),
          word: "意大利面|Yìdàlìmiàn",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-02.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_05.mp3"),
          word: "饼干|bǐnggān",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-03.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_06.mp3"),
          word: "葡萄|pútao",
        },
        //

        {
          img: require("@data/assets/green/book2/images/img_G2-07.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_07.mp3"),
          word: "你吃什么？|Nǐ chī shénme?",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-09.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_08.mp3"),
          word: "我吃汉堡包。|Wǒ chī hànbǎobāo.",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-08.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_09.mp3"),
          word: "我吃蛋糕。|Wǒ chī dàngāo.",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-11.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_10.mp3"),
          word: "我吃冰淇淋。|Wǒ chī bīngqílín. ",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-10.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_11.mp3"),
          word: "我吃意大利面。|Wǒ chī Yìdàlìmiàn.",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-13.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_12.mp3"),
          word: "我吃饼干。|Wǒ chī bǐnggān. ",
        },
        {
          img: require("@data/assets/green/book2/images/img_G2-12.png"),
          sound: require("@data/assets/green/book2/sounds/KD02_W_13.mp3"),
          word: "我吃葡萄。|Wǒ chī pútao.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book2/images/img_G2-04.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_01.mp3"),
        buttons: [{ ch2: "hànbǎobāo" }, { ch: "汉堡包" }, { ko: "햄버거" }],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-05.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_02.mp3"),
        buttons: [{ ch2: "dàngāo" }, { ch: "蛋糕" }, { ko: "케이크" }],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-06.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_03.mp3"),
        buttons: [{ ch2: "bīngqílín" }, { ch: "冰淇淋" }, { ko: "아이스크림" }],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-01.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_04.mp3"),
        buttons: [{ ch2: "Yìdàlìmiàn" }, { ch: "意大利面" }, { ko: "파스타" }],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-02.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_05.mp3"),
        buttons: [{ ch2: "bǐnggān" }, { ch: "饼干" }, { ko: "비스킷" }],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-03.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_06.mp3"),
        buttons: [{ ch2: "pútao" }, { ch: "葡萄" }, { ko: "포도" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book2/images/img_G2-07.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ chī shénme?" },
          { ch: "你吃什么？" },
          { ko: "너는 뭘 먹어?" },
        ],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-09.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ chī hànbǎobāo." },
          { ch: "我吃汉堡包。" },
          { ko: "나는 햄버거 먹어." },
        ],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-08.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ chī dàngāo." },
          { ch: "我吃蛋糕。" },
          { ko: "나는 케이크 먹어." },
        ],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-11.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ chī bīngqílín." },
          { ch: "我吃冰淇淋。" },
          { ko: "나는 아이스크림 먹어." },
        ],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-10.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ chī Yìdàlìmiàn." },
          { ch: "我吃意大利面。" },
          { ko: "나는 파스타 먹어." },
        ],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-13.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ chī bǐnggān." },
          { ch: "我吃饼干。" },
          { ko: "나는 비스킷 먹어." },
        ],
      },
      {
        img: require("@data/assets/green/book2/images/img_G2-12.png"),
        sound: require("@data/assets/green/book2/sounds/KD02_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ chī pútao." },
          { ch: "我吃葡萄。" },
          { ko: "나는 포도 먹어." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book2/sounds/KD02_W_05.mp3"),
          img: require("@data/assets/green/book2/images/img_G2-06.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book2/sounds/KD02_W_04.mp3"),
          answer: [
            [require("@data/assets/green/book2/images/img_G2-02.png"), false],
            [require("@data/assets/green/book2/images/img_G2-01.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book2/sounds/KD02_W_01.mp3"),
          answer: [
            ["冰淇淋", false],
            ["汉堡包", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book2/pages/front.jpg"),
        sound: require("@data/assets/green/book2/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book2/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page04.jpg"),
        sound: require("@data/assets/green/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page06.jpg"),
        sound: require("@data/assets/green/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page08.jpg"),
        sound: require("@data/assets/green/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page10.jpg"),
        sound: require("@data/assets/green/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page12.jpg"),
        sound: require("@data/assets/green/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page14.jpg"),
        sound: require("@data/assets/green/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page16.jpg"),
        sound: require("@data/assets/green/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page18.jpg"),
        sound: require("@data/assets/green/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page20.jpg"),
        sound: require("@data/assets/green/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page22.jpg"),
        sound: require("@data/assets/green/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page23.jpg"),
        sound: require("@data/assets/green/book2/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book2/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book2/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book2/thumbnail/front.jpg"),
      require("@data/assets/green/book2/thumbnail/page02.jpg"),
      require("@data/assets/green/book2/thumbnail/page03.jpg"),
      require("@data/assets/green/book2/thumbnail/page04.jpg"),
      require("@data/assets/green/book2/thumbnail/page05.jpg"),
      require("@data/assets/green/book2/thumbnail/page06.jpg"),
      require("@data/assets/green/book2/thumbnail/page07.jpg"),
      require("@data/assets/green/book2/thumbnail/page08.jpg"),
      require("@data/assets/green/book2/thumbnail/page09.jpg"),
      require("@data/assets/green/book2/thumbnail/page10.jpg"),
      require("@data/assets/green/book2/thumbnail/page11.jpg"),
      require("@data/assets/green/book2/thumbnail/page12.jpg"),
      require("@data/assets/green/book2/thumbnail/page13.jpg"),
      require("@data/assets/green/book2/thumbnail/page14.jpg"),
      require("@data/assets/green/book2/thumbnail/page15.jpg"),
      require("@data/assets/green/book2/thumbnail/page16.jpg"),
      require("@data/assets/green/book2/thumbnail/page17.jpg"),
      require("@data/assets/green/book2/thumbnail/page18.jpg"),
      require("@data/assets/green/book2/thumbnail/page19.jpg"),
      require("@data/assets/green/book2/thumbnail/page20.jpg"),
      require("@data/assets/green/book2/thumbnail/page21.jpg"),
      require("@data/assets/green/book2/thumbnail/page22.jpg"),
      require("@data/assets/green/book2/thumbnail/page23.jpg"),
      require("@data/assets/green/book2/thumbnail/page24.jpg"),
      require("@data/assets/green/book2/thumbnail/page25.jpg"),
      require("@data/assets/green/book2/thumbnail/page26.jpg"),
      require("@data/assets/green/book2/thumbnail/page27.jpg"),
    ],
  },
  //3
  {
    key: "c4-03",
    title: "뒤죽박죽 서커스단",
    grade: "3권",
    cover: require("@data/assets/green/book3/images/cover.jpg"),
    background: require("@data/assets/green/book3/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book3/sounds/page23.mp3"),
      title: "Nǐ zhǎo shénme?",
      caption: [
        "zhǎo zhǎo nǐ zhǎo shénme shǒubiǎo wǒ zhǎo shǒubiǎo",
        "kùzi wǒ zhǎo kùzi màozi wǒ zhǎo màozi",
        "zhǎo dào le zhǎo dào le zhǎo dào le la la la la la la",
        "zhǎo zhǎo nǐ zhǎo shénme yǎnjìng wǒ zhǎo yǎnjìng",
        "wàzi wǒ zhǎo wàzi xiézi wǒ zhǎo xiézi",
        "zhǎo dào le zhǎo dào le zhǎo dào le la la la la la la",
        "zhǎo dào le",
      ],
    },
    mov: {
      cn: "44afe5d627b191f6dcea31e0cb5b4094_03",
      en: "7ed1372ae776e4ae1c7a0ead5506bcbe_03",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book3/images/img_G3-03.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_01.mp3"),
          word: "手表|shǒubiǎo",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-02.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_02.mp3"),
          word: "裤子|kùzi",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-01.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_03.mp3"),
          word: "帽子|màozi",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-06.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_04.mp3"),
          word: "眼镜|yǎnjìng",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-05.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_05.mp3"),
          word: "袜子|wàzi",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-04.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_06.mp3"),
          word: "鞋子|xiézi",
        },
        //

        {
          img: require("@data/assets/green/book3/images/img_G3-07.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_07.mp3"),
          word: "你找什么?|Nǐ zhǎo shénme?",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-09.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_08.mp3"),
          word: "我找手表。|Wǒ zhǎo shǒubiǎo.",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-08.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_09.mp3"),
          word: "我找裤子。|Wǒ zhǎo kùzi.",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-11.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_10.mp3"),
          word: "我找帽子。|Wǒ zhǎo màozi.",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-10.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_11.mp3"),
          word: "我找眼镜。|Wǒ zhǎo yǎnjìng.",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-13.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_12.mp3"),
          word: "我找袜子。|Wǒ zhǎo wàzi.",
        },
        {
          img: require("@data/assets/green/book3/images/img_G3-12.png"),
          sound: require("@data/assets/green/book3/sounds/KD03_W_13.mp3"),
          word: "我找鞋子。|Wǒ zhǎo xiézi.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book3/images/img_G3-03.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_01.mp3"),
        buttons: [{ ch2: "shǒubiǎo" }, { ch: "手表" }, { ko: "시계" }],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-02.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_02.mp3"),
        buttons: [{ ch2: "kùzi" }, { ch: "裤子" }, { ko: "바지" }],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-01.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_03.mp3"),
        buttons: [{ ch2: "màozi" }, { ch: "帽子" }, { ko: "모자" }],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-06.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_04.mp3"),
        buttons: [{ ch2: "yǎnjìng" }, { ch: "眼镜" }, { ko: "안경" }],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-05.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_05.mp3"),
        buttons: [{ ch2: "wàzi" }, { ch: "袜子" }, { ko: "양말" }],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-04.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_06.mp3"),
        buttons: [{ ch2: "xiézi" }, { ch: "鞋子" }, { ko: "신발" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book3/images/img_G3-07.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ zhǎo shénme?" },
          { ch: "你找什么?" },
          { ko: "너는 뭘 찾아?" },
        ],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-09.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ zhǎo shǒubiǎo." },
          { ch: "我找手表。" },
          { ko: "나는 시계 찾아." },
        ],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-08.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ zhǎo kùzi." },
          { ch: "我找裤子。" },
          { ko: "나는 바지 찾아." },
        ],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-11.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ zhǎo màozi." },
          { ch: "我找帽子。" },
          { ko: "나는 모자 찾아." },
        ],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-10.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ zhǎo yǎnjìng." },
          { ch: "我找眼镜。" },
          { ko: "나는 안경을 찾아." },
        ],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-13.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ zhǎo wàzi." },
          { ch: "我找袜子。" },
          { ko: "나는 양말을 찾아." },
        ],
      },
      {
        img: require("@data/assets/green/book3/images/img_G3-12.png"),
        sound: require("@data/assets/green/book3/sounds/KD03_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ zhǎo xiézi." },
          { ch: "我找鞋子。" },
          { ko: "나는 신발을 찾아." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book3/sounds/KD03_W_02.mp3"),
          img: require("@data/assets/green/book3/images/img_G3-05.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book3/sounds/KD03_W_04.mp3"),
          answer: [
            [require("@data/assets/green/book3/images/img_G3-03.png"), false],
            [require("@data/assets/green/book3/images/img_G3-06.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book3/sounds/KD03_W_06.mp3"),
          answer: [
            ["鞋子", true],
            ["手表", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book3/pages/front.jpg"),
        sound: require("@data/assets/green/book3/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book3/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page04.jpg"),
        sound: require("@data/assets/green/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page06.jpg"),
        sound: require("@data/assets/green/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page08.jpg"),
        sound: require("@data/assets/green/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page10.jpg"),
        sound: require("@data/assets/green/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page12.jpg"),
        sound: require("@data/assets/green/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page14.jpg"),
        sound: require("@data/assets/green/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page16.jpg"),
        sound: require("@data/assets/green/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page18.jpg"),
        sound: require("@data/assets/green/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page20.jpg"),
        sound: require("@data/assets/green/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page22.jpg"),
        sound: require("@data/assets/green/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page23.jpg"),
        sound: require("@data/assets/green/book3/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book3/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book3/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book3/thumbnail/front.jpg"),
      require("@data/assets/green/book3/thumbnail/page02.jpg"),
      require("@data/assets/green/book3/thumbnail/page03.jpg"),
      require("@data/assets/green/book3/thumbnail/page04.jpg"),
      require("@data/assets/green/book3/thumbnail/page05.jpg"),
      require("@data/assets/green/book3/thumbnail/page06.jpg"),
      require("@data/assets/green/book3/thumbnail/page07.jpg"),
      require("@data/assets/green/book3/thumbnail/page08.jpg"),
      require("@data/assets/green/book3/thumbnail/page09.jpg"),
      require("@data/assets/green/book3/thumbnail/page10.jpg"),
      require("@data/assets/green/book3/thumbnail/page11.jpg"),
      require("@data/assets/green/book3/thumbnail/page12.jpg"),
      require("@data/assets/green/book3/thumbnail/page13.jpg"),
      require("@data/assets/green/book3/thumbnail/page14.jpg"),
      require("@data/assets/green/book3/thumbnail/page15.jpg"),
      require("@data/assets/green/book3/thumbnail/page16.jpg"),
      require("@data/assets/green/book3/thumbnail/page17.jpg"),
      require("@data/assets/green/book3/thumbnail/page18.jpg"),
      require("@data/assets/green/book3/thumbnail/page19.jpg"),
      require("@data/assets/green/book3/thumbnail/page20.jpg"),
      require("@data/assets/green/book3/thumbnail/page21.jpg"),
      require("@data/assets/green/book3/thumbnail/page22.jpg"),
      require("@data/assets/green/book3/thumbnail/page23.jpg"),
      require("@data/assets/green/book3/thumbnail/page24.jpg"),
      require("@data/assets/green/book3/thumbnail/page25.jpg"),
      require("@data/assets/green/book3/thumbnail/page26.jpg"),
      require("@data/assets/green/book3/thumbnail/page27.jpg"),
    ],
  },
  //4
  {
    key: "c4-04",
    title: "따라쟁이 내동생",
    grade: "4권",
    cover: require("@data/assets/green/book4/images/cover.jpg"),
    background: require("@data/assets/green/book4/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book4/sounds/page23.mp3"),
      title: "Nǐ zuò shénme?",
      caption: [
        "nǐ zuò shénme wǒ tīng yīnyuè nǐ zuò shénme wǒ tīng yīnyuè",
        "nǐ zuò shénme wǒ chī fàn nǐ zuò shénme wǒ chī fàn",
        "nǐ zuò shénme wǒ xuéxí  wǒ xuéxí",
        "nǐ zuò shénme wǒ xǐ liǎn nǐ zuò shénme wǒ xǐ liǎn",
        "nǐ zuò shénme wǒ kàn shū nǐ zuò shénme wǒ kàn shū",
        "nǐ zuò shénme wǒ tiàowǔ wǒ tiàowǔ",
      ],
    },
    mov: {
      cn: "6d4edc9e9fbfee6c60e67931fb5cb236_04",
      en: "e1c45155d3d5319b023a65eaf32fa883_04",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book4/images/img_G4-03.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_01.mp3"),
          word: "听音乐|tīng yīnyuè",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-02.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_02.mp3"),
          word: "吃饭|chī fàn",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-01.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_03.mp3"),
          word: "洗脸|xǐ liǎn",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-06.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_04.mp3"),
          word: "学习|xuéxí",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-05.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_05.mp3"),
          word: "看书|kàn shū",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-04.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_06.mp3"),
          word: "跳舞|tiàowǔ",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-07.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_07.mp3"),
          word: "你做什么？|Nǐ zuò shénme?",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-09.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_08.mp3"),
          word: "我听音乐。|Wǒ tīng yīnyuè.",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-08.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_09.mp3"),
          word: "我吃饭。|Wǒ chī fàn.",
        },
        {
          img: require("@data/assets/green/book4/images/img_G4-11.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_10.mp3"),
          word: "我洗脸。|Wǒ xǐ liǎn.",
        },
        /*
        {
          img: require("@data/assets/green/book4/images/img_G4-10.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_11.mp3"),
          word: "我学习。|Wǒ xuéxí.",
        },
        
        {
          img: require("@data/assets/green/book4/images/img_G4-13.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_12.mp3"),
          word: "我看书。|Wǒ kàn shū.",
        },
        */
        {
          img: require("@data/assets/green/book4/images/img_G4-12.png"),
          sound: require("@data/assets/green/book4/sounds/KD04_W_13.mp3"),
          word: "我跳舞。|Wǒ tiàowǔ.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book4/images/img_G4-03.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_01.mp3"),
        buttons: [
          { ch2: "tīng yīnyuè" },
          { ch: "听音乐" },
          { ko: "음악을 듣다" },
        ],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-02.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_02.mp3"),
        buttons: [{ ch2: "chī fàn" }, { ch: "吃饭" }, { ko: "밥을 먹다" }],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-01.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_03.mp3"),
        buttons: [{ ch2: "xǐ liǎn" }, { ch: "洗脸" }, { ko: "세수를 하다" }],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-06.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_04.mp3"),
        buttons: [{ ch2: "xuéxí" }, { ch: "学习" }, { ko: "공부를 하다" }],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-05.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_05.mp3"),
        buttons: [{ ch2: "kàn shū" }, { ch: "看书" }, { ko: "책을 보다" }],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-04.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_06.mp3"),
        buttons: [{ ch2: "tiàowǔ" }, { ch: "跳舞" }, { ko: "춤을 추다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book4/images/img_G4-07.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ zuò shénme?" },
          { ch: "你做什么？" },
          { ko: "너는 무엇을 하고 있어?" },
        ],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-09.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ tīng yīnyuè." },
          { ch: "我听音乐。" },
          { ko: "나는 음악을 들어." },
        ],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-08.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ chī fàn." },
          { ch: "我吃饭。" },
          { ko: "나는 밥 먹어." },
        ],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-11.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ xǐ liǎn." },
          { ch: "我洗脸。" },
          { ko: "나는 세수를 해." },
        ],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-10.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ xuéxí." },
          { ch: "我学习。" },
          { ko: "나는 공부를 해." },
        ],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-13.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ kàn shū." },
          { ch: "我看书。" },
          { ko: "나는 책을 봐." },
        ],
      },
      {
        img: require("@data/assets/green/book4/images/img_G4-12.png"),
        sound: require("@data/assets/green/book4/sounds/KD04_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ tiàowǔ." },
          { ch: "我跳舞。" },
          { ko: "나는 춤을 춰." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book4/sounds/KD04_W_01.mp3"),
          img: require("@data/assets/green/book4/images/img_G4-03.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book4/sounds/KD04_W_04.mp3"),
          answer: [
            [require("@data/assets/green/book4/images/img_G4-06.png"), true],
            [require("@data/assets/green/book4/images/img_G4-04.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book4/sounds/KD04_W_06.mp3"),
          answer: [
            ["跳舞", true],
            ["洗脸", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book4/pages/front.jpg"),
        sound: require("@data/assets/green/book4/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book4/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page04.jpg"),
        sound: require("@data/assets/green/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page06.jpg"),
        sound: require("@data/assets/green/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page08.jpg"),
        sound: require("@data/assets/green/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page10.jpg"),
        sound: require("@data/assets/green/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page12.jpg"),
        sound: require("@data/assets/green/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page14.jpg"),
        sound: require("@data/assets/green/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page16.jpg"),
        sound: require("@data/assets/green/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page18.jpg"),
        sound: require("@data/assets/green/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page20.jpg"),
        sound: require("@data/assets/green/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page22.jpg"),
        sound: require("@data/assets/green/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page23.jpg"),
        sound: require("@data/assets/green/book4/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book4/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book4/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book4/thumbnail/front.jpg"),
      require("@data/assets/green/book4/thumbnail/page02.jpg"),
      require("@data/assets/green/book4/thumbnail/page03.jpg"),
      require("@data/assets/green/book4/thumbnail/page04.jpg"),
      require("@data/assets/green/book4/thumbnail/page05.jpg"),
      require("@data/assets/green/book4/thumbnail/page06.jpg"),
      require("@data/assets/green/book4/thumbnail/page07.jpg"),
      require("@data/assets/green/book4/thumbnail/page08.jpg"),
      require("@data/assets/green/book4/thumbnail/page09.jpg"),
      require("@data/assets/green/book4/thumbnail/page10.jpg"),
      require("@data/assets/green/book4/thumbnail/page11.jpg"),
      require("@data/assets/green/book4/thumbnail/page12.jpg"),
      require("@data/assets/green/book4/thumbnail/page13.jpg"),
      require("@data/assets/green/book4/thumbnail/page14.jpg"),
      require("@data/assets/green/book4/thumbnail/page15.jpg"),
      require("@data/assets/green/book4/thumbnail/page16.jpg"),
      require("@data/assets/green/book4/thumbnail/page17.jpg"),
      require("@data/assets/green/book4/thumbnail/page18.jpg"),
      require("@data/assets/green/book4/thumbnail/page19.jpg"),
      require("@data/assets/green/book4/thumbnail/page20.jpg"),
      require("@data/assets/green/book4/thumbnail/page21.jpg"),
      require("@data/assets/green/book4/thumbnail/page22.jpg"),
      require("@data/assets/green/book4/thumbnail/page23.jpg"),
      require("@data/assets/green/book4/thumbnail/page24.jpg"),
      require("@data/assets/green/book4/thumbnail/page25.jpg"),
      require("@data/assets/green/book4/thumbnail/page26.jpg"),
      require("@data/assets/green/book4/thumbnail/page27.jpg"),
    ],
  },
  //5
  {
    key: "c4-05",
    title: "누구를 그리니?",
    grade: "5권",
    cover: require("@data/assets/green/book5/images/cover.jpg"),
    background: require("@data/assets/green/book5/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book5/sounds/page23.mp3"),
      title: "Tā shì shéi?",
      caption: [
        "shéi shéi tā shì shéi shéi shéi tā shì shéi",
        "māma māma tā shì wǒ māma wǒ ài wǒ māma",
        "bàba bàba tā shì wǒ bàba wǒ ài wǒ bàba",
        "nǎinai nǎinai tā shì wǒ nǎinai wǒ ài wǒ nǎinai",
        "shéi shéi tā shì shéi shéi shéi tā shì shéi",
        "yéye yéye tā shì wǒ yéye wǒ ài wǒ yéye",
        "péngyou péngyou tā shì wǒ de péngyou",
        "wǒ ài wǒ de péngyou",
        "lǎoshī lǎoshī tā shì wǒ de lǎoshī wǒ ài wǒ de lǎoshī",
      ],
    },
    mov: {
      cn: "b2dabb1654af7c23fb099f1809ffb3bf_05",
      en: "4a4f6251f60e987b27706a7b29c6970d_05",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book5/images/img_G5-03.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_01.mp3"),
          word: "妈妈|māma",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-02.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_02.mp3"),
          word: "爸爸|bàba ",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-01.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_03.mp3"),
          word: "爷爷|yéye",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-06.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_04.mp3"),
          word: "奶奶|nǎinai",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-05.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_05.mp3"),
          word: "朋友|péngyou",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-04.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_06.mp3"),
          word: "老师|lǎoshī ",
        },
        //

        {
          img: require("@data/assets/green/book5/images/img_G5-07.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_07.mp3"),
          word: "他(她)是谁？|Tā(tā) shì shéi?",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-09.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_08.mp3"),
          word: "她是我妈妈。|Tā shì wǒ māma.",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-08.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_09.mp3"),
          word: "他是我爸爸。|Tā shì wǒ bàba.",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-10.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_10.mp3"),
          word: "他是我爷爷。|Tā shì wǒ yéye.",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-11.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_11.mp3"),
          word: "她是我奶奶。|Tā shì wǒ nǎinai.",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-13.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_12.mp3"),
          word: "她是我的朋友。|Tā shì wǒ de péngyou.",
        },
        {
          img: require("@data/assets/green/book5/images/img_G5-12.png"),
          sound: require("@data/assets/green/book5/sounds/KD05_W_13.mp3"),
          word: "她是我的老师。|Tā shì wǒ de lǎoshī. ",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book5/images/img_G5-03.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_01.mp3"),
        buttons: [{ ch2: "māma" }, { ch: "妈妈" }, { ko: "엄마" }],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-02.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_02.mp3"),
        buttons: [{ ch2: "bàba" }, { ch: "爸爸" }, { ko: "아빠" }],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-01.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_03.mp3"),
        buttons: [{ ch2: "yéye" }, { ch: "爷爷" }, { ko: "할아버지" }],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-06.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_04.mp3"),
        buttons: [{ ch2: "nǎinai" }, { ch: "奶奶" }, { ko: "할머니" }],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-05.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_05.mp3"),
        buttons: [{ ch2: "péngyou" }, { ch: "朋友" }, { ko: "친구" }],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-04.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_06.mp3"),
        buttons: [{ ch2: "lǎoshī" }, { ch: "老师" }, { ko: "선생님" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book5/images/img_G5-07.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_07.mp3"),
        buttons: [
          { ch2: "Tā(tā) shì shéi?" },
          { ch: "他(她)是谁？" },
          { ko: "그(그녀)는 누구야?" },
        ],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-09.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_08.mp3"),
        buttons: [
          { ch2: "Tā shì wǒ māma." },
          { ch: "她是我妈妈。" },
          { ko: "그녀는 우리 엄마야." },
        ],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-08.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_09.mp3"),
        buttons: [
          { ch2: "Tā shì wǒ bàba." },
          { ch: "他是我爸爸。" },
          { ko: "그는 우리 아빠야." },
        ],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-10.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_10.mp3"),
        buttons: [
          { ch2: "Tā shì wǒ yéye." },
          { ch: "他是我爷爷。" },
          { ko: "그는 우리 할아버지야." },
        ],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-11.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_11.mp3"),
        buttons: [
          { ch2: "Tā shì wǒ nǎinai." },
          { ch: "她是我奶奶。" },
          { ko: "그녀는 우리 할머니야." },
        ],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-13.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_12.mp3"),
        buttons: [
          { ch2: "Tā shì wǒ de péngyou." },
          { ch: "她是我的朋友。" },
          { ko: "그녀는 내 친구야." },
        ],
      },
      {
        img: require("@data/assets/green/book5/images/img_G5-12.png"),
        sound: require("@data/assets/green/book5/sounds/KD05_W_13.mp3"),
        buttons: [
          { ch2: "Tā shì wǒ de lǎoshī." },
          { ch: "她是我的老师。" },
          { ko: "그녀는 우리 선생님이야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book5/sounds/KD05_W_03.mp3"),
          img: require("@data/assets/green/book5/images/img_G5-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book5/sounds/KD05_W_02.mp3"),
          answer: [
            [require("@data/assets/green/book5/images/img_G5-04.png"), false],
            [require("@data/assets/green/book5/images/img_G5-02.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book5/sounds/KD05_W_05.mp3"),
          answer: [
            ["朋友", true],
            ["老师", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book5/pages/front.jpg"),
        sound: require("@data/assets/green/book5/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book5/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page04.jpg"),
        sound: require("@data/assets/green/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page06.jpg"),
        sound: require("@data/assets/green/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page08.jpg"),
        sound: require("@data/assets/green/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page10.jpg"),
        sound: require("@data/assets/green/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page12.jpg"),
        sound: require("@data/assets/green/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page14.jpg"),
        sound: require("@data/assets/green/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page16.jpg"),
        sound: require("@data/assets/green/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page18.jpg"),
        sound: require("@data/assets/green/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page20.jpg"),
        sound: require("@data/assets/green/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page22.jpg"),
        sound: require("@data/assets/green/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page23.jpg"),
        sound: require("@data/assets/green/book5/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book5/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book5/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book5/thumbnail/front.jpg"),
      require("@data/assets/green/book5/thumbnail/page02.jpg"),
      require("@data/assets/green/book5/thumbnail/page03.jpg"),
      require("@data/assets/green/book5/thumbnail/page04.jpg"),
      require("@data/assets/green/book5/thumbnail/page05.jpg"),
      require("@data/assets/green/book5/thumbnail/page06.jpg"),
      require("@data/assets/green/book5/thumbnail/page07.jpg"),
      require("@data/assets/green/book5/thumbnail/page08.jpg"),
      require("@data/assets/green/book5/thumbnail/page09.jpg"),
      require("@data/assets/green/book5/thumbnail/page10.jpg"),
      require("@data/assets/green/book5/thumbnail/page11.jpg"),
      require("@data/assets/green/book5/thumbnail/page12.jpg"),
      require("@data/assets/green/book5/thumbnail/page13.jpg"),
      require("@data/assets/green/book5/thumbnail/page14.jpg"),
      require("@data/assets/green/book5/thumbnail/page15.jpg"),
      require("@data/assets/green/book5/thumbnail/page16.jpg"),
      require("@data/assets/green/book5/thumbnail/page17.jpg"),
      require("@data/assets/green/book5/thumbnail/page18.jpg"),
      require("@data/assets/green/book5/thumbnail/page19.jpg"),
      require("@data/assets/green/book5/thumbnail/page20.jpg"),
      require("@data/assets/green/book5/thumbnail/page21.jpg"),
      require("@data/assets/green/book5/thumbnail/page22.jpg"),
      require("@data/assets/green/book5/thumbnail/page23.jpg"),
      require("@data/assets/green/book5/thumbnail/page24.jpg"),
      require("@data/assets/green/book5/thumbnail/page25.jpg"),
      require("@data/assets/green/book5/thumbnail/page26.jpg"),
      require("@data/assets/green/book5/thumbnail/page27.jpg"),
    ],
  },
  //6
  {
    key: "c4-06",
    title: "캠프는 즐거워!",
    grade: "6권",
    cover: require("@data/assets/green/book6/images/cover.jpg"),
    background: require("@data/assets/green/book6/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book6/sounds/page23.mp3"),
      title: "Nǐ shì nǎ guó rén?",
      caption: [
        "nǐ hǎo  nǐ hǎo nǐ shì nǎ guó rén",
        "wǒ shì Hánguórén wǒ shì Hánguórén",
        "wǒ shì Zhōngguórén  wǒ shì Zhōngguórén",
        "wǒ shì Yìndùrén wǒ shì Yìndùrén",
        "rènshi nǐ hěn gāoxìng",
        "nǐ hǎo  nǐ hǎo nǐ shì nǎ guó rén",
        "wǒ shì Měiguórén  wǒ shì Měiguórén",
        "wǒ shì Fǎguórén wǒ shì Fǎguórén",
        "wǒ shì Rìběnrén  wǒ shì Rìběnrén",
        "rènshi nǐ hěn gāoxìng",
      ],
    },
    mov: {
      cn: "7ea43c1af2748d8504e8b6095e226f81_06",
      en: "17d2045e298631786e0f9d5a3feadc4f_06",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book6/images/img_G6-02.png"),
          sound: require("@data/assets/green/book6/sounds/KD06_W_02.mp3"),
          word: "中国人|Zhōngguórén",
        },
        {
          img: require("@data/assets/green/book6/images/img_G6-06.png"),
          sound: require("@data/assets/green/book6/sounds/KD06_W_04.mp3"),
          word: "法国人|Fǎguórén",
        },
        {
          img: require("@data/assets/green/book6/images/img_G6-04.png"),
          sound: require("@data/assets/green/book6/sounds/KD06_W_06.mp3"),
          word: "印度人|Yìndùrén",
        },
        {
          img: require("@data/assets/green/book6/images/img_G6-07.png"),
          sound: require("@data/assets/green/book6/sounds/KD06_W_07.mp3"),
          word: "你是哪国人？|Nǐ shì nǎ guó rén?",
        },
        {
          img: require("@data/assets/green/book6/images/img_G6-03.png"),
          sound: require("@data/assets/green/book6/sounds/KD06_W_08.mp3"),
          word: "我是韩国人。|Wǒ shì Hánguórén.",
        },
        {
          img: require("@data/assets/green/book6/images/img_G6-01.png"),
          sound: require("@data/assets/green/book6/sounds/KD06_W_10.mp3"),
          word: "我是美国人。|Wǒ shì Měiguórén.",
        },
        {
          img: require("@data/assets/green/book6/images/img_G6-05.png"),
          sound: require("@data/assets/green/book6/sounds/KD06_W_12.mp3"),
          word: "我是日本人。|Wǒ shì Rìběnrén.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book6/images/img_G6-03.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_01.mp3"),
        buttons: [{ ch2: "Hánguórén" }, { ch: "韩国人" }, { ko: "한국인" }],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-02.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_02.mp3"),
        buttons: [{ ch2: "Zhōngguórén" }, { ch: "中国人" }, { ko: "중국인" }],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-01.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_03.mp3"),
        buttons: [{ ch2: "Měiguórén" }, { ch: "美国人" }, { ko: "미국인" }],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-06.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_04.mp3"),
        buttons: [{ ch2: "Fǎguórén" }, { ch: "法国人" }, { ko: "프랑스인" }],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-05.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_05.mp3"),
        buttons: [{ ch2: "Rìběnrén" }, { ch: "日本人" }, { ko: "일본인" }],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-04.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_06.mp3"),
        buttons: [{ ch2: "Yìndùrén" }, { ch: "印度人" }, { ko: "인도인" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book6/images/img_G6-07.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ shì nǎ guó rén?" },
          { ch: "你是哪国人？" },
          { ko: "너는 어느 나라 사람이야?" },
        ],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-03.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ shì Hánguórén." },
          { ch: "我是韩国人。" },
          { ko: "나는 한국인이야." },
        ],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-02.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ shì Zhōngguórén." },
          { ch: "我是中国人。" },
          { ko: "나는 중국인이야." },
        ],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-01.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ shì Měiguórén." },
          { ch: "我是美国人。" },
          { ko: "나는 미국인이야." },
        ],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-06.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ shì Fǎguórén." },
          { ch: "我是法国人。" },
          { ko: "나는 프랑스인이야." },
        ],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-05.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ shì Rìběnrén." },
          { ch: "我是日本人。" },
          { ko: "나는 일본인이야." },
        ],
      },
      {
        img: require("@data/assets/green/book6/images/img_G6-04.png"),
        sound: require("@data/assets/green/book6/sounds/KD06_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ shì Yìndùrén." },
          { ch: "我是印度人。" },
          { ko: "나는 인도인이야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book6/sounds/KD06_W_05.mp3"),
          img: require("@data/assets/green/book6/images/img_G6-06.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book6/sounds/KD06_W_03.mp3"),
          answer: [
            [require("@data/assets/green/book6/images/img_G6-02.png"), false],
            [require("@data/assets/green/book6/images/img_G6-01.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book6/sounds/KD06_W_01.mp3"),
          answer: [
            ["韩国人", true],
            ["法国人", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book6/pages/front.jpg"),
        sound: require("@data/assets/green/book6/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book6/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page04.jpg"),
        sound: require("@data/assets/green/book6/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page06.jpg"),
        sound: require("@data/assets/green/book6/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page08.jpg"),
        sound: require("@data/assets/green/book6/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page10.jpg"),
        sound: require("@data/assets/green/book6/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page12.jpg"),
        sound: require("@data/assets/green/book6/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page14.jpg"),
        sound: require("@data/assets/green/book6/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page16.jpg"),
        sound: require("@data/assets/green/book6/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page18.jpg"),
        sound: require("@data/assets/green/book6/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page20.jpg"),
        sound: require("@data/assets/green/book6/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page22.jpg"),
        sound: require("@data/assets/green/book6/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page23.jpg"),
        sound: require("@data/assets/green/book6/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book6/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book6/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book6/thumbnail/front.jpg"),
      require("@data/assets/green/book6/thumbnail/page02.jpg"),
      require("@data/assets/green/book6/thumbnail/page03.jpg"),
      require("@data/assets/green/book6/thumbnail/page04.jpg"),
      require("@data/assets/green/book6/thumbnail/page05.jpg"),
      require("@data/assets/green/book6/thumbnail/page06.jpg"),
      require("@data/assets/green/book6/thumbnail/page07.jpg"),
      require("@data/assets/green/book6/thumbnail/page08.jpg"),
      require("@data/assets/green/book6/thumbnail/page09.jpg"),
      require("@data/assets/green/book6/thumbnail/page10.jpg"),
      require("@data/assets/green/book6/thumbnail/page11.jpg"),
      require("@data/assets/green/book6/thumbnail/page12.jpg"),
      require("@data/assets/green/book6/thumbnail/page13.jpg"),
      require("@data/assets/green/book6/thumbnail/page14.jpg"),
      require("@data/assets/green/book6/thumbnail/page15.jpg"),
      require("@data/assets/green/book6/thumbnail/page16.jpg"),
      require("@data/assets/green/book6/thumbnail/page17.jpg"),
      require("@data/assets/green/book6/thumbnail/page18.jpg"),
      require("@data/assets/green/book6/thumbnail/page19.jpg"),
      require("@data/assets/green/book6/thumbnail/page20.jpg"),
      require("@data/assets/green/book6/thumbnail/page21.jpg"),
      require("@data/assets/green/book6/thumbnail/page22.jpg"),
      require("@data/assets/green/book6/thumbnail/page23.jpg"),
      require("@data/assets/green/book6/thumbnail/page24.jpg"),
      require("@data/assets/green/book6/thumbnail/page25.jpg"),
      require("@data/assets/green/book6/thumbnail/page26.jpg"),
      require("@data/assets/green/book6/thumbnail/page27.jpg"),
    ],
  },
  //7
  {
    key: "c4-07",
    title: "나는 심부름을 잘해요",
    grade: "7권",
    cover: require("@data/assets/green/book7/images/cover.jpg"),
    background: require("@data/assets/green/book7/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book7/sounds/page23.mp3"),
      title: "Nǐ qù nǎr?",
      caption: [
        "nǐ qù nǎr nǐ qù nǎr nǐ qù nǎr",
        "yóulèchǎng wǒ qù yóulèchǎng nǐ ne",
        "chāoshì chāoshì wǒ qù chāoshì nǐ ne",
        "yīyuàn yīyuàn wǒ qù yīyuàn zàijiàn",
        "nǐ qù nǎr nǐ qù nǎr nǐ qù nǎr",
        "diànyǐngyuàn wǒ qù diànyǐngyuàn nǐ ne",
        "yóuyǒngchí yóuyǒngchí wǒ qù yóuyǒngchí nǐ ne",
        "cāntīng cāntīng wǒ qù cāntīng zàijiàn",
      ],
    },
    mov: {
      cn: "4b30e13e408bd486cfc54e74cf92a9c1_07",
      en: "10454e794606b418262d1f42e892b028_07",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book7/images/img_G7-03.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_01.mp3"),
          word: "医院|yīyuàn",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-02.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_02.mp3"),
          word: "超市|chāoshì",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-01.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_03.mp3"),
          word: "游乐场|yóulèchǎng",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-06.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_04.mp3"),
          word: "电影院|diànyǐngyuàn",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-05.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_05.mp3"),
          word: "游泳池|yóuyǒngchí",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-04.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_06.mp3"),
          word: "餐厅|cāntīng",
        },
        //

        {
          img: require("@data/assets/green/book7/images/img_G7-07.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_07.mp3"),
          word: "你去哪儿?|Nǐ qù nǎr?",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-09.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_08.mp3"),
          word: "我去医院。|Wǒ qù yīyuàn.",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-08.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_09.mp3"),
          word: "我去超市。|Wǒ qù chāoshì. ",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-11.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_10.mp3"),
          word: "我去游乐场。|Wǒ qù yóulèchǎng.",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-10.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_11.mp3"),
          word: "我去电影院。|Wǒ qù diànyǐngyuàn.",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-13.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_12.mp3"),
          word: "我去游泳池。|Wǒ qù yóuyǒngchí.",
        },
        {
          img: require("@data/assets/green/book7/images/img_G7-12.png"),
          sound: require("@data/assets/green/book7/sounds/KD07_W_13.mp3"),
          word: "我去餐厅。|Wǒ qù cāntīng.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book7/images/img_G7-03.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_01.mp3"),
        buttons: [{ ch2: "yīyuàn" }, { ch: "医院" }, { ko: "병원" }],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-02.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_02.mp3"),
        buttons: [{ ch2: "chāoshì" }, { ch: "超市" }, { ko: "슈퍼마켓" }],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-01.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_03.mp3"),
        buttons: [{ ch2: "yóulèchǎng" }, { ch: "游乐场" }, { ko: "놀이터" }],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-06.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_04.mp3"),
        buttons: [
          { ch2: "diànyǐngyuàn" },
          { ch: "电影院" },
          { ko: "영화관, 극장" },
        ],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-05.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_05.mp3"),
        buttons: [{ ch2: "yóuyǒngchí" }, { ch: "游泳池" }, { ko: "수영장" }],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-04.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_06.mp3"),
        buttons: [{ ch2: "cāntīng" }, { ch: "餐厅" }, { ko: "식당" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book7/images/img_G7-07.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ qù nǎr?" },
          { ch: "你去哪儿?" },
          { ko: "너는 어디에 가?" },
        ],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-09.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ qù yīyuàn." },
          { ch: "我去医院。" },
          { ko: "나는 병원에 가." },
        ],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-08.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ qù chāoshì. " },
          { ch: "我去超市。" },
          { ko: "나는 슈퍼마켓에 가." },
        ],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-11.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ qù yóulèchǎng." },
          { ch: "我去游乐场。" },
          { ko: "나는 놀이터에 가." },
        ],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-10.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ qù diànyǐngyuàn." },
          { ch: "我去电影院。" },
          { ko: "나는 영화관에 가." },
        ],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-13.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ qù yóuyǒngchí." },
          { ch: "我去游泳池。" },
          { ko: "나는 수영장에 가." },
        ],
      },
      {
        img: require("@data/assets/green/book7/images/img_G7-12.png"),
        sound: require("@data/assets/green/book7/sounds/KD07_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ qù cāntīng." },
          { ch: "我去餐厅。" },
          { ko: "나는 식당에 가." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book7/sounds/KD07_W_06.mp3"),
          img: require("@data/assets/green/book7/images/img_G7-01.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book7/sounds/KD07_W_03.mp3"),
          answer: [
            [require("@data/assets/green/book7/images/img_G7-01.png"), true],
            [require("@data/assets/green/book7/images/img_G7-02.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book7/sounds/KD07_W_05.mp3"),
          answer: [
            ["游泳池", true],
            ["电影院", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book7/pages/front.jpg"),
        sound: require("@data/assets/green/book7/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book7/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page04.jpg"),
        sound: require("@data/assets/green/book7/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page06.jpg"),
        sound: require("@data/assets/green/book7/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page08.jpg"),
        sound: require("@data/assets/green/book7/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page10.jpg"),
        sound: require("@data/assets/green/book7/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page12.jpg"),
        sound: require("@data/assets/green/book7/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page14.jpg"),
        sound: require("@data/assets/green/book7/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page16.jpg"),
        sound: require("@data/assets/green/book7/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page18.jpg"),
        sound: require("@data/assets/green/book7/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page20.jpg"),
        sound: require("@data/assets/green/book7/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page22.jpg"),
        sound: require("@data/assets/green/book7/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page23.jpg"),
        sound: require("@data/assets/green/book7/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book7/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book7/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book7/thumbnail/front.jpg"),
      require("@data/assets/green/book7/thumbnail/page02.jpg"),
      require("@data/assets/green/book7/thumbnail/page03.jpg"),
      require("@data/assets/green/book7/thumbnail/page04.jpg"),
      require("@data/assets/green/book7/thumbnail/page05.jpg"),
      require("@data/assets/green/book7/thumbnail/page06.jpg"),
      require("@data/assets/green/book7/thumbnail/page07.jpg"),
      require("@data/assets/green/book7/thumbnail/page08.jpg"),
      require("@data/assets/green/book7/thumbnail/page09.jpg"),
      require("@data/assets/green/book7/thumbnail/page10.jpg"),
      require("@data/assets/green/book7/thumbnail/page11.jpg"),
      require("@data/assets/green/book7/thumbnail/page12.jpg"),
      require("@data/assets/green/book7/thumbnail/page13.jpg"),
      require("@data/assets/green/book7/thumbnail/page14.jpg"),
      require("@data/assets/green/book7/thumbnail/page15.jpg"),
      require("@data/assets/green/book7/thumbnail/page16.jpg"),
      require("@data/assets/green/book7/thumbnail/page17.jpg"),
      require("@data/assets/green/book7/thumbnail/page18.jpg"),
      require("@data/assets/green/book7/thumbnail/page19.jpg"),
      require("@data/assets/green/book7/thumbnail/page20.jpg"),
      require("@data/assets/green/book7/thumbnail/page21.jpg"),
      require("@data/assets/green/book7/thumbnail/page22.jpg"),
      require("@data/assets/green/book7/thumbnail/page23.jpg"),
      require("@data/assets/green/book7/thumbnail/page24.jpg"),
      require("@data/assets/green/book7/thumbnail/page25.jpg"),
      require("@data/assets/green/book7/thumbnail/page26.jpg"),
      require("@data/assets/green/book7/thumbnail/page27.jpg"),
    ],
  },
  //8
  {
    key: "c4-08",
    title: "인형들의 숨바꼭질",
    grade: "8권",
    cover: require("@data/assets/green/book8/images/cover.jpg"),
    background: require("@data/assets/green/book8/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book8/sounds/page23.mp3"),
      title: "Nǐ zài nǎr?",
      caption: [
        "nǐ zài nǎr zài nǎr wǒ zài fángjiān wǒ xuéxí",
        "wǒ zài xǐshǒujiān wǒ xǐ liǎn wǒ zài chúfáng wǒ zuò cài",
        "nǐ zài nǎr zài nǎr wǒ zài shūfáng wǒ kàn shū",
        "wǒ zài kètīng wǒ kàn diànshì wǒ zài yángtái la la la la la la la",
      ],
    },
    mov: {
      cn: "f6f27fd8ffc7f6027e96cc2e4f484cf1_08",
      en: "d3e33332192aad39b89a776c5d91e700_08",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book8/images/img_G8-03.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_01.mp3"),
          word: "房间|fángjiān",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-02.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_02.mp3"),
          word: "客厅|kètīng",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-01.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_03.mp3"),
          word: "厨房|chúfáng ",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-06.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_04.mp3"),
          word: "书房|shūfáng",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-05.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_05.mp3"),
          word: "洗手间|xǐshǒujiān",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-04.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_06.mp3"),
          word: "阳台|yángtái",
        },
        //

        {
          img: require("@data/assets/green/book8/images/img_G8-07.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_07.mp3"),
          word: "你在哪儿？|Nǐ zài nǎr? ",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-09.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_08.mp3"),
          word: "我在房间。|Wǒ zài fángjiān.",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-08.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_09.mp3"),
          word: "我在客厅。|Wǒ zài kètīng.",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-11.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_10.mp3"),
          word: "我在厨房。|Wǒ zài chúfáng.",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-10.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_11.mp3"),
          word: "我在书房。|Wǒ zài shūfáng.",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-13.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_12.mp3"),
          word: "我在洗手间。|Wǒ zài xǐshǒujiān.",
        },
        {
          img: require("@data/assets/green/book8/images/img_G8-12.png"),
          sound: require("@data/assets/green/book8/sounds/KD08_W_13.mp3"),
          word: "我在阳台。|Wǒ zài yángtái.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book8/images/img_G8-03.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_01.mp3"),
        buttons: [{ ch2: "fángjiān" }, { ch: "房间" }, { ko: "방" }],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-02.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_02.mp3"),
        buttons: [{ ch2: "kètīng" }, { ch: "客厅" }, { ko: "거실" }],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-01.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_03.mp3"),
        buttons: [{ ch2: "chúfáng" }, { ch: "厨房" }, { ko: "부엌, 주방" }],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-06.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_04.mp3"),
        buttons: [{ ch2: "shūfáng" }, { ch: "书房" }, { ko: "서재" }],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-05.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_05.mp3"),
        buttons: [{ ch2: "xǐshǒujiān" }, { ch: "洗手间" }, { ko: "화장실" }],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-04.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_06.mp3"),
        buttons: [{ ch2: "yángtái" }, { ch: "阳台" }, { ko: "베란다, 테라스" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book8/images/img_G8-07.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ zài nǎr? " },
          { ch: "你在哪儿？" },
          { ko: "너는 어디에 있어?" },
        ],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-09.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ zài fángjiān." },
          { ch: "我在房间。" },
          { ko: "나는 방에 있어." },
        ],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-08.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ zài kètīng." },
          { ch: "我在客厅。" },
          { ko: "나는 거실에 있어." },
        ],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-11.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ zài chúfáng." },
          { ch: "我在厨房。" },
          { ko: "나는 주방에 있어." },
        ],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-10.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ zài shūfáng." },
          { ch: "我在书房。" },
          { ko: "나는 서재에 있어." },
        ],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-13.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ zài xǐshǒujiān." },
          { ch: "我在洗手间。" },
          { ko: "나는 화장실에 있어." },
        ],
      },
      {
        img: require("@data/assets/green/book8/images/img_G8-12.png"),
        sound: require("@data/assets/green/book8/sounds/KD08_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ zài yángtái." },
          { ch: "我在阳台。" },
          { ko: "나는 베란다에 있어." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book8/sounds/KD08_W_05.mp3"),
          img: require("@data/assets/green/book8/images/img_G8-01.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book8/sounds/KD08_W_06.mp3"),
          answer: [
            [require("@data/assets/green/book8/images/img_G8-03.png"), false],
            [require("@data/assets/green/book8/images/img_G8-04.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book8/sounds/KD08_W_02.mp3"),
          answer: [
            ["客厅", true],
            ["书房", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book8/pages/front.jpg"),
        sound: require("@data/assets/green/book8/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book8/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page04.jpg"),
        sound: require("@data/assets/green/book8/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page06.jpg"),
        sound: require("@data/assets/green/book8/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page08.jpg"),
        sound: require("@data/assets/green/book8/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page10.jpg"),
        sound: require("@data/assets/green/book8/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page12.jpg"),
        sound: require("@data/assets/green/book8/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page14.jpg"),
        sound: require("@data/assets/green/book8/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page16.jpg"),
        sound: require("@data/assets/green/book8/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page18.jpg"),
        sound: require("@data/assets/green/book8/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page20.jpg"),
        sound: require("@data/assets/green/book8/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page22.jpg"),
        sound: require("@data/assets/green/book8/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page23.jpg"),
        sound: require("@data/assets/green/book8/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book8/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book8/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book8/thumbnail/front.jpg"),
      require("@data/assets/green/book8/thumbnail/page02.jpg"),
      require("@data/assets/green/book8/thumbnail/page03.jpg"),
      require("@data/assets/green/book8/thumbnail/page04.jpg"),
      require("@data/assets/green/book8/thumbnail/page05.jpg"),
      require("@data/assets/green/book8/thumbnail/page06.jpg"),
      require("@data/assets/green/book8/thumbnail/page07.jpg"),
      require("@data/assets/green/book8/thumbnail/page08.jpg"),
      require("@data/assets/green/book8/thumbnail/page09.jpg"),
      require("@data/assets/green/book8/thumbnail/page10.jpg"),
      require("@data/assets/green/book8/thumbnail/page11.jpg"),
      require("@data/assets/green/book8/thumbnail/page12.jpg"),
      require("@data/assets/green/book8/thumbnail/page13.jpg"),
      require("@data/assets/green/book8/thumbnail/page14.jpg"),
      require("@data/assets/green/book8/thumbnail/page15.jpg"),
      require("@data/assets/green/book8/thumbnail/page16.jpg"),
      require("@data/assets/green/book8/thumbnail/page17.jpg"),
      require("@data/assets/green/book8/thumbnail/page18.jpg"),
      require("@data/assets/green/book8/thumbnail/page19.jpg"),
      require("@data/assets/green/book8/thumbnail/page20.jpg"),
      require("@data/assets/green/book8/thumbnail/page21.jpg"),
      require("@data/assets/green/book8/thumbnail/page22.jpg"),
      require("@data/assets/green/book8/thumbnail/page23.jpg"),
      require("@data/assets/green/book8/thumbnail/page24.jpg"),
      require("@data/assets/green/book8/thumbnail/page25.jpg"),
      require("@data/assets/green/book8/thumbnail/page26.jpg"),
      require("@data/assets/green/book8/thumbnail/page27.jpg"),
    ],
  },
  //9
  {
    key: "c4-09",
    title: "학교가 좋아!",
    grade: "9권",
    cover: require("@data/assets/green/book9/images/cover.jpg"),
    background: require("@data/assets/green/book9/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book9/sounds/page23.mp3"),
      title: "Jīntiān xīngqī jǐ?",
      caption: [
        "yī èr sān sì wǔ liù yī èr sān sì  wǔ liù",
        "xīngqīyī xīngqī'èr xīngqīsān",
        "jīntiān xīngqī jǐ xīngqī jǐ",
        "jīntiān xīngqīyī jīntiān xīngqī'èr jīntiān xīngqīsān",
        "yī èr sān sì wǔ liù yī èr sān sì  wǔ liù",
        "xīngqīsì xīngqīwǔ xīngqīliù",
        "jīntiān xīngqī jǐ xīngqī jǐ",
        "jīntiān xīngqīsì jīntiān xīngqīwǔ jīntiān xīngqīliù",
        "wā jīntiān xīngqītiān zhēn kāixīn",
      ],
    },
    mov: {
      cn: "86baba14bbc1b9cb0f03115063092b4f_09",
      en: "d3e2b8462549f5157ea137b4e085a57b_09",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book9/images/img_G9-03.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_01.mp3"),
          word: "星期一|xīngqīyī",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-02.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_02.mp3"),
          word: "星期二|xīngqī'èr",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-01.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_03.mp3"),
          word: "星期三|xīngqīsān",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-06.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_04.mp3"),
          word: "星期四|xīngqīsì",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-05.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_05.mp3"),
          word: "星期五|xīngqīwǔ",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-04.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_06.mp3"),
          word: "星期六|xīngqīliù",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-15.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_07.mp3"),
          word: "星期天|xīngqītiān",
        },
        //

        {
          img: require("@data/assets/green/book9/images/img_G9-07.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_08.mp3"),
          word: "今天星期几？|Jīntiān xīngqī jǐ? ",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-09.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_09.mp3"),
          word: "今天星期一。|Jīntiān xīngqīyī.",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-08.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_10.mp3"),
          word: "今天星期二。|Jīntiān xīngqī'èr.",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-11.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_11.mp3"),
          word: "今天星期三。|Jīntiān xīngqīsān.",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-10.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_12.mp3"),
          word: "今天星期四。|Jīntiān xīngqīsì.",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-13.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_13.mp3"),
          word: "今天星期五。|Jīntiān xīngqīwǔ.",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-12.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_14.mp3"),
          word: "今天星期六。|Jīntiān xīngqīliù.",
        },
        {
          img: require("@data/assets/green/book9/images/img_G9-14.png"),
          sound: require("@data/assets/green/book9/sounds/KD09_W_15.mp3"),
          word: "今天星期天。|Jīntiān xīngqītiān.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book9/images/img_G9-03.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_01.mp3"),
        buttons: [{ ch2: "xīngqīyī" }, { ch: "星期一" }, { ko: "월요일" }],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-02.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_02.mp3"),
        buttons: [{ ch2: "xīngqī'èr" }, { ch: "星期二" }, { ko: "화요일" }],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-01.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_03.mp3"),
        buttons: [{ ch2: "xīngqīsān" }, { ch: "星期三" }, { ko: "수요일" }],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-06.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_04.mp3"),
        buttons: [{ ch2: "xīngqīsì" }, { ch: "星期四" }, { ko: "목요일" }],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-05.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_05.mp3"),
        buttons: [{ ch2: "xīngqīwǔ" }, { ch: "星期五" }, { ko: "금요일" }],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-04.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_06.mp3"),
        buttons: [{ ch2: "xīngqīliù" }, { ch: "星期六" }, { ko: "토요일" }],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-15.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_07.mp3"),
        buttons: [{ ch2: "xīngqītiān" }, { ch: "星期天" }, { ko: "일요일" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book9/images/img_G9-07.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_08.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqī jǐ?" },
          { ch: "今天星期几？" },
          { ko: "오늘은 무슨 요일이야?" },
        ],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-09.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_09.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqīyī." },
          { ch: "今天星期一。" },
          { ko: "오늘은 월요일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-08.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_10.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqī'èr." },
          { ch: "今天星期二。" },
          { ko: "오늘은 화요일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-11.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_11.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqīsān." },
          { ch: "今天星期三。" },
          { ko: "오늘은 수요일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-10.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_12.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqīsì." },
          { ch: "今天星期四。" },
          { ko: "오늘은 목요일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-13.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_13.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqīwǔ." },
          { ch: "今天星期五。" },
          { ko: "오늘은 금요일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-12.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_14.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqīliù." },
          { ch: "今天星期六。" },
          { ko: "오늘은 토요일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book9/images/img_G9-14.png"),
        sound: require("@data/assets/green/book9/sounds/KD09_W_15.mp3"),
        buttons: [
          { ch2: "Jīntiān xīngqītiān." },
          { ch: "今天星期天。" },
          { ko: "오늘은 일요일이야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book9/sounds/KD09_W_04.mp3"),
          img: require("@data/assets/green/book9/images/img_G9-06.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book9/sounds/KD09_W_02.mp3"),
          answer: [
            [require("@data/assets/green/book9/images/img_G9-04.png"), false],
            [require("@data/assets/green/book9/images/img_G9-02.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book9/sounds/KD09_W_05.mp3"),
          answer: [
            ["星期天", false],
            ["星期五", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book9/pages/front.jpg"),
        sound: require("@data/assets/green/book9/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book9/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page04.jpg"),
        sound: require("@data/assets/green/book9/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page06.jpg"),
        sound: require("@data/assets/green/book9/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page08.jpg"),
        sound: require("@data/assets/green/book9/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page10.jpg"),
        sound: require("@data/assets/green/book9/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page12.jpg"),
        sound: require("@data/assets/green/book9/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page14.jpg"),
        sound: require("@data/assets/green/book9/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page16.jpg"),
        sound: require("@data/assets/green/book9/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page18.jpg"),
        sound: require("@data/assets/green/book9/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page20.jpg"),
        sound: require("@data/assets/green/book9/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page22.jpg"),
        sound: require("@data/assets/green/book9/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page23.jpg"),
        sound: require("@data/assets/green/book9/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book9/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book9/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book9/thumbnail/front.jpg"),
      require("@data/assets/green/book9/thumbnail/page02.jpg"),
      require("@data/assets/green/book9/thumbnail/page03.jpg"),
      require("@data/assets/green/book9/thumbnail/page04.jpg"),
      require("@data/assets/green/book9/thumbnail/page05.jpg"),
      require("@data/assets/green/book9/thumbnail/page06.jpg"),
      require("@data/assets/green/book9/thumbnail/page07.jpg"),
      require("@data/assets/green/book9/thumbnail/page08.jpg"),
      require("@data/assets/green/book9/thumbnail/page09.jpg"),
      require("@data/assets/green/book9/thumbnail/page10.jpg"),
      require("@data/assets/green/book9/thumbnail/page11.jpg"),
      require("@data/assets/green/book9/thumbnail/page12.jpg"),
      require("@data/assets/green/book9/thumbnail/page13.jpg"),
      require("@data/assets/green/book9/thumbnail/page14.jpg"),
      require("@data/assets/green/book9/thumbnail/page15.jpg"),
      require("@data/assets/green/book9/thumbnail/page16.jpg"),
      require("@data/assets/green/book9/thumbnail/page17.jpg"),
      require("@data/assets/green/book9/thumbnail/page18.jpg"),
      require("@data/assets/green/book9/thumbnail/page19.jpg"),
      require("@data/assets/green/book9/thumbnail/page20.jpg"),
      require("@data/assets/green/book9/thumbnail/page21.jpg"),
      require("@data/assets/green/book9/thumbnail/page22.jpg"),
      require("@data/assets/green/book9/thumbnail/page23.jpg"),
      require("@data/assets/green/book9/thumbnail/page24.jpg"),
      require("@data/assets/green/book9/thumbnail/page25.jpg"),
      require("@data/assets/green/book9/thumbnail/page26.jpg"),
      require("@data/assets/green/book9/thumbnail/page27.jpg"),
    ],
  },
  //10
  {
    key: "c4-10",
    title: "거짓말하면 안돼요",
    grade: "10권",
    cover: require("@data/assets/green/book10/images/cover.jpg"),
    background: require("@data/assets/green/book10/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book10/sounds/page23.mp3"),
      title: "Nǐ jǐ suì?",
      caption: [
        "nǐ jǐ suì wǔ wǔ wǔ suì wǒ wǔ suì",
        "nǐ gēge jǐ suì liù liù liù suì wǒ gēge liù suì",
        "nǐ jiějie jǐ suì qī qī qī suì wǒ jiějie qī suì",
        "tā jǐ suì  bā bā  bā suì  tā bā suì",
        "tā gēge jǐ suì jiǔ jiǔ jiǔ suì tā gēge jiǔ suì",
        "tā jiějie jǐ suì shí shí  shí suì tā jiějie shí suì",
      ],
    },
    mov: {
      cn: "7c28846d3612e6700543e046b43ac1eb_10",
      en: "6987aaa5c397c28b3c90bc76d9511de5_10",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book10/images/img_G10-02.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_01.mp3"),
          word: "五岁|wǔ suì",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-01.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_02.mp3"),
          word: "六岁|liù suì",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-06.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_03.mp3"),
          word: "七岁|qī suì",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-05.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_04.mp3"),
          word: "八岁|bā suì",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-04.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_05.mp3"),
          word: "九岁|jiǔ suì",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-03.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_06.mp3"),
          word: "十岁|shí suì",
        },
        //

        {
          img: require("@data/assets/green/book10/images/img_G10-07.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_07.mp3"),
          word: "你几岁？|Nǐ jǐ suì? ",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-09.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_08.mp3"),
          word: "我五岁。|Wǒ wǔ suì. ",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-08.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_09.mp3"),
          word: "我六岁。|Wǒ liù suì.",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-11.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_10.mp3"),
          word: "我七岁。|Wǒ qī suì.",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-10.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_11.mp3"),
          word: "我八岁。|Wǒ bā suì.",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-13.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_12.mp3"),
          word: "我九岁。|Wǒ jiǔ suì.",
        },
        {
          img: require("@data/assets/green/book10/images/img_G10-12.png"),
          sound: require("@data/assets/green/book10/sounds/KD10_W_13.mp3"),
          word: "我十岁。|Wǒ shí suì.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book10/images/img_G10-02.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_01.mp3"),
        buttons: [{ ch2: "wǔ suì" }, { ch: "五岁" }, { ko: "다섯 살(5살)" }],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-01.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_02.mp3"),
        buttons: [{ ch2: "liù suì" }, { ch: "六岁" }, { ko: "여섯 살(6살)" }],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-06.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_03.mp3"),
        buttons: [{ ch2: "qī suì" }, { ch: "七岁" }, { ko: "일곱 살(7살)" }],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-05.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_04.mp3"),
        buttons: [{ ch2: "bā suì" }, { ch: "八岁" }, { ko: "여덟 살(8살)" }],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-04.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_05.mp3"),
        buttons: [{ ch2: "jiǔ suì" }, { ch: "九岁" }, { ko: "아홉 살(9살)" }],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-03.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_06.mp3"),
        buttons: [{ ch2: "shí suì" }, { ch: "十岁" }, { ko: "열 살(10살)" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book10/images/img_G10-07.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ jǐ suì?" },
          { ch: "你几岁？" },
          { ko: "너는 몇 살이야?" },
        ],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-09.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ wǔ suì." },
          { ch: "我五岁。" },
          { ko: "나는 다섯 살이야." },
        ],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-08.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ liù suì." },
          { ch: "我六岁。" },
          { ko: "나는 여섯 살이야." },
        ],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-11.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ qī suì." },
          { ch: "我七岁。" },
          { ko: "나는 일곱 살이야." },
        ],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-10.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ bā suì." },
          { ch: "我八岁。" },
          { ko: "나는 여덟 살이야." },
        ],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-13.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ jiǔ suì." },
          { ch: "我九岁。" },
          { ko: "나는 아홉 살이야." },
        ],
      },
      {
        img: require("@data/assets/green/book10/images/img_G10-12.png"),
        sound: require("@data/assets/green/book10/sounds/KD10_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ shí suì." },
          { ch: "我十岁。" },
          { ko: "나는 열 살이야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book10/sounds/KD10_W_02.mp3"),
          img: require("@data/assets/green/book10/images/img_G10-03.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book10/sounds/KD10_W_01.mp3"),
          answer: [
            [require("@data/assets/green/book10/images/img_G10-04.png"), false],
            [require("@data/assets/green/book10/images/img_G10-02.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book10/sounds/KD10_W_04.mp3"),
          answer: [
            ["八岁", true],
            ["十岁", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book10/pages/front.jpg"),
        sound: require("@data/assets/green/book10/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book10/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page04.jpg"),
        sound: require("@data/assets/green/book10/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page06.jpg"),
        sound: require("@data/assets/green/book10/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page08.jpg"),
        sound: require("@data/assets/green/book10/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page10.jpg"),
        sound: require("@data/assets/green/book10/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page12.jpg"),
        sound: require("@data/assets/green/book10/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page14.jpg"),
        sound: require("@data/assets/green/book10/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page16.jpg"),
        sound: require("@data/assets/green/book10/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page18.jpg"),
        sound: require("@data/assets/green/book10/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page20.jpg"),
        sound: require("@data/assets/green/book10/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page22.jpg"),
        sound: require("@data/assets/green/book10/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page23.jpg"),
        sound: require("@data/assets/green/book10/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book10/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book10/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book10/thumbnail/front.jpg"),
      require("@data/assets/green/book10/thumbnail/page02.jpg"),
      require("@data/assets/green/book10/thumbnail/page03.jpg"),
      require("@data/assets/green/book10/thumbnail/page04.jpg"),
      require("@data/assets/green/book10/thumbnail/page05.jpg"),
      require("@data/assets/green/book10/thumbnail/page06.jpg"),
      require("@data/assets/green/book10/thumbnail/page07.jpg"),
      require("@data/assets/green/book10/thumbnail/page08.jpg"),
      require("@data/assets/green/book10/thumbnail/page09.jpg"),
      require("@data/assets/green/book10/thumbnail/page10.jpg"),
      require("@data/assets/green/book10/thumbnail/page11.jpg"),
      require("@data/assets/green/book10/thumbnail/page12.jpg"),
      require("@data/assets/green/book10/thumbnail/page13.jpg"),
      require("@data/assets/green/book10/thumbnail/page14.jpg"),
      require("@data/assets/green/book10/thumbnail/page15.jpg"),
      require("@data/assets/green/book10/thumbnail/page16.jpg"),
      require("@data/assets/green/book10/thumbnail/page17.jpg"),
      require("@data/assets/green/book10/thumbnail/page18.jpg"),
      require("@data/assets/green/book10/thumbnail/page19.jpg"),
      require("@data/assets/green/book10/thumbnail/page20.jpg"),
      require("@data/assets/green/book10/thumbnail/page21.jpg"),
      require("@data/assets/green/book10/thumbnail/page22.jpg"),
      require("@data/assets/green/book10/thumbnail/page23.jpg"),
      require("@data/assets/green/book10/thumbnail/page24.jpg"),
      require("@data/assets/green/book10/thumbnail/page25.jpg"),
      require("@data/assets/green/book10/thumbnail/page26.jpg"),
      require("@data/assets/green/book10/thumbnail/page27.jpg"),
    ],
  },
  //11
  {
    key: "c4-11",
    title: "산타 할아버지는 바빠요",
    grade: "11권",
    cover: require("@data/assets/green/book11/images/cover.jpg"),
    background: require("@data/assets/green/book11/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book11/sounds/page23.mp3"),
      title: "Xiànzài jǐ diǎn?",
      caption: [
        "xiànzài jǐ diǎn xiànzài yī diǎn",
        "xiànzài jǐ diǎn xiànzài liǎng diǎn",
        "xiànzài jǐ diǎn xiànzài sān diǎn",
        "sì diǎn wǔ diǎn liù diǎn",
        "xiànzài jǐ diǎn xiànzài qī diǎn",
        "xiànzài jǐ diǎn xiànzài bā diǎn",
        "xiànzài jǐ diǎn xiànzài jiǔ diǎn",
        "shí diǎn shíyī diǎn shí'èr diǎn",
      ],
    },
    mov: {
      cn: "03b3f08f2087593154bf1e7a282f70af_11",
      en: "1ae3909215106a022142666baa4f1489_11",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book11/images/img_G11-02.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_01.mp3"),
          word: "十点|shí diǎn",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-01.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_02.mp3"),
          word: "十一点|shíyī diǎn",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-06.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_03.mp3"),
          word: "十二点|shí'èr diǎn",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-05.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_04.mp3"),
          word: "一点|yī diǎn",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-04.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_05.mp3"),
          word: "两点|liǎng diǎn",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-03.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_06.mp3"),
          word: "六点|liù diǎn",
        },
        //

        {
          img: require("@data/assets/green/book11/images/img_G11-07.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_07.mp3"),
          word: "现在几点？|Xiànzài jǐ diǎn?",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-09.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_08.mp3"),
          word: "现在一点。|Xiànzài yī diǎn.",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-08.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_09.mp3"),
          word: "现在两点。|Xiànzài liǎng diǎn.",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-11.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_10.mp3"),
          word: "现在六点。|Xiànzài liù diǎn.",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-10.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_11.mp3"),
          word: "现在十点。|Xiànzài shí diǎn.",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-13.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_12.mp3"),
          word: "现在十一点。|Xiànzài shíyī diǎn.",
        },
        {
          img: require("@data/assets/green/book11/images/img_G11-12.png"),
          sound: require("@data/assets/green/book11/sounds/KD11_W_13.mp3"),
          word: "现在十二点。|Xiànzài shí'èr diǎn.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book11/images/img_G11-02.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_01.mp3"),
        buttons: [{ ch2: "shí diǎn" }, { ch: "十点" }, { ko: "열 시(10시)" }],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-01.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_02.mp3"),
        buttons: [
          { ch2: "shíyī diǎn" },
          { ch: "十一点" },
          { ko: "열한 시(11시)" },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-06.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_03.mp3"),
        buttons: [
          { ch2: "shí'èr diǎn" },
          { ch: "十二点" },
          { ko: "열두 시(12시)" },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-05.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_04.mp3"),
        buttons: [{ ch2: "yī diǎn" }, { ch: "一点" }, { ko: "한 시(1시)" }],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-04.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_05.mp3"),
        buttons: [{ ch2: "liǎng diǎn" }, { ch: "两点" }, { ko: "두 시(2시)" }],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-03.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_06.mp3"),
        buttons: [{ ch2: "liù diǎn" }, { ch: "六点" }, { ko: "여섯 시(6시)" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book11/images/img_G11-07.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_07.mp3"),
        buttons: [
          { ch2: "Xiànzài jǐ diǎn?" },
          { ch: "现在几点？" },
          { ko: "지금 몇 시야?" },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-09.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_08.mp3"),
        buttons: [
          { ch2: "Xiànzài yī diǎn." },
          { ch: "现在一点。" },
          { ko: "지금 한 시야." },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-08.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_09.mp3"),
        buttons: [
          { ch2: "Xiànzài liǎng diǎn." },
          { ch: "现在两点。" },
          { ko: "지금 두 시야." },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-11.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_10.mp3"),
        buttons: [
          { ch2: "Xiànzài liù diǎn." },
          { ch: "现在六点。" },
          { ko: "지금 여섯 시야." },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-10.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_11.mp3"),
        buttons: [
          { ch2: "Xiànzài shí diǎn." },
          { ch: "现在十点。" },
          { ko: "지금 열 시야." },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-13.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_12.mp3"),
        buttons: [
          { ch2: "Xiànzài shíyī diǎn." },
          { ch: "现在十一点。" },
          { ko: "지금 열한 시야." },
        ],
      },
      {
        img: require("@data/assets/green/book11/images/img_G11-12.png"),
        sound: require("@data/assets/green/book11/sounds/KD11_W_13.mp3"),
        buttons: [
          { ch2: "Xiànzài shí'èr diǎn." },
          { ch: "现在十二点。" },
          { ko: "지금 열두 시야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book11/sounds/KD11_W_04.mp3"),
          img: require("@data/assets/green/book11/images/img_G11-06.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book11/sounds/KD11_W_05.mp3"),
          answer: [
            [require("@data/assets/green/book11/images/img_G11-04.png"), true],
            [require("@data/assets/green/book11/images/img_G11-02.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book11/sounds/KD11_W_02.mp3"),
          answer: [
            ["十一点", true],
            ["六点", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book11/pages/front.jpg"),
        sound: require("@data/assets/green/book11/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book11/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page04.jpg"),
        sound: require("@data/assets/green/book11/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page06.jpg"),
        sound: require("@data/assets/green/book11/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page08.jpg"),
        sound: require("@data/assets/green/book11/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page10.jpg"),
        sound: require("@data/assets/green/book11/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page12.jpg"),
        sound: require("@data/assets/green/book11/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page14.jpg"),
        sound: require("@data/assets/green/book11/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page16.jpg"),
        sound: require("@data/assets/green/book11/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page18.jpg"),
        sound: require("@data/assets/green/book11/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page20.jpg"),
        sound: require("@data/assets/green/book11/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page22.jpg"),
        sound: require("@data/assets/green/book11/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page23.jpg"),
        sound: require("@data/assets/green/book11/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book11/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book11/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book11/thumbnail/front.jpg"),
      require("@data/assets/green/book11/thumbnail/page02.jpg"),
      require("@data/assets/green/book11/thumbnail/page03.jpg"),
      require("@data/assets/green/book11/thumbnail/page04.jpg"),
      require("@data/assets/green/book11/thumbnail/page05.jpg"),
      require("@data/assets/green/book11/thumbnail/page06.jpg"),
      require("@data/assets/green/book11/thumbnail/page07.jpg"),
      require("@data/assets/green/book11/thumbnail/page08.jpg"),
      require("@data/assets/green/book11/thumbnail/page09.jpg"),
      require("@data/assets/green/book11/thumbnail/page10.jpg"),
      require("@data/assets/green/book11/thumbnail/page11.jpg"),
      require("@data/assets/green/book11/thumbnail/page12.jpg"),
      require("@data/assets/green/book11/thumbnail/page13.jpg"),
      require("@data/assets/green/book11/thumbnail/page14.jpg"),
      require("@data/assets/green/book11/thumbnail/page15.jpg"),
      require("@data/assets/green/book11/thumbnail/page16.jpg"),
      require("@data/assets/green/book11/thumbnail/page17.jpg"),
      require("@data/assets/green/book11/thumbnail/page18.jpg"),
      require("@data/assets/green/book11/thumbnail/page19.jpg"),
      require("@data/assets/green/book11/thumbnail/page20.jpg"),
      require("@data/assets/green/book11/thumbnail/page21.jpg"),
      require("@data/assets/green/book11/thumbnail/page22.jpg"),
      require("@data/assets/green/book11/thumbnail/page23.jpg"),
      require("@data/assets/green/book11/thumbnail/page24.jpg"),
      require("@data/assets/green/book11/thumbnail/page25.jpg"),
      require("@data/assets/green/book11/thumbnail/page26.jpg"),
      require("@data/assets/green/book11/thumbnail/page27.jpg"),
    ],
  },
  //12
  {
    key: "c4-12",
    title: "나는 언제 꽃이 필까?",
    grade: "12권",
    cover: require("@data/assets/green/book12/images/cover.jpg"),
    background: require("@data/assets/green/book12/pages/page05.jpg"),
    song: {
      url: require("@data/assets/green/book12/sounds/page23.mp3"),
      title: "Jīntiān jǐ yuè jǐ hào?",
      caption: [
        "zǎoshang hǎo jīntiān jǐ yuè jǐ hào",
        "yī yuè yī hào jīntiān yī yuè yī hào",
        "sān yuè shísì hào jīntiān sān yuè shísì hào",
        "wǔ yuè èrshí hào jīntiān wǔ yuè èrshí hào",
        "zǎoshang hǎo jīntiān jǐ yuè jǐ hào",
        "bā yuè shíwǔ hào jīntiān bā yuè shíwǔ hào",
        "shí yuè èrshí'èr hào jīntiān shí yuè èrshí'èr hào",
        "shí'èr yuè sānshíyī hào jīntiān shí'èr yuè sānshíyī hào",
      ],
    },
    mov: {
      cn: "2571fb7c177c0006c28b800f269d267b_12",
      en: "7d4fb235cc00d3354df130d79e8d1ed8_12",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/green/book12/images/img_G12-02.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_01.mp3"),
          word: "三月一号|sān yuè yī hào",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-01.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_02.mp3"),
          word: "三月五号|sān yuè wǔ hào",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-06.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_03.mp3"),
          word: "四月二十号|sì yuè èrshí hào",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-05.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_04.mp3"),
          word: "五月二十一号|wǔ yuè èrshíyī hào",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-04.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_05.mp3"),
          word: "六月二十二号|liù yuè èrshí'èr hào",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-07.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_06.mp3"),
          word: "七月三十号|qī yuè sānshí hào",
        },
        //

        {
          img: require("@data/assets/green/book12/images/img_G12-14.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_07.mp3"),
          word: "今天几月几号？|Jīntiān jǐ yuè jǐ hào? ",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-12.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_08.mp3"),
          word: "今天三月一号。|Jīntiān sān yuè yī hào.",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-13.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_09.mp3"),
          word: "今天三月五号。|Jīntiān sān yuè wǔ hào.",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-10.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_10.mp3"),
          word: "今天四月二十号。|Jīntiān sì yuè èrshí hào.",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-11.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_11.mp3"),
          word: "今天五月二十一号。|Jīntiān wǔ yuè èrshíyī hào.",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-08.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_12.mp3"),
          word: "今天六月二十二号。|Jīntiān liù yuè èrshí'èr hào.",
        },
        {
          img: require("@data/assets/green/book12/images/img_G12-09.png"),
          sound: require("@data/assets/green/book12/sounds/KD12_W_13.mp3"),
          word: "今天七月三十号。|Jīntiān qī yuè sānshí hào.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/green/book12/images/img_G12-02.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_01.mp3"),
        buttons: [
          { ch2: "sān yuè yī hào" },
          { ch: "三月一号" },
          { ko: "3월 1일" },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-01.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_02.mp3"),
        buttons: [
          { ch2: "sān yuè wǔ hào" },
          { ch: "三月五号" },
          { ko: "3월 5일" },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-06.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_03.mp3"),
        buttons: [
          { ch2: "sì yuè èrshí hào" },
          { ch: "四月二十号" },
          { ko: "4월 20일" },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-05.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_04.mp3"),
        buttons: [
          { ch2: "wǔ yuè èrshíyī hào" },
          { ch: "五月二十一号" },
          { ko: "5월 21일" },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-04.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_05.mp3"),
        buttons: [
          { ch2: "liù yuè èrshí'èr hào" },
          { ch: "六月二十二号" },
          { ko: "6월 22일" },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-07.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_06.mp3"),
        buttons: [
          { ch2: "qī yuè sānshí hào" },
          { ch: "七月三十号" },
          { ko: "7월 30일" },
        ],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/green/book12/images/img_G12-14.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_07.mp3"),
        buttons: [
          { ch2: "Jīntiān jǐ yuè jǐ hào?" },
          { ch: "今天几月几号？" },
          { ko: "오늘은 몇 월 며칠이야?" },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-12.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_08.mp3"),
        buttons: [
          { ch2: "Jīntiān sān yuè yī hào." },
          { ch: "今天三月一号。" },
          { ko: "오늘은 3월 1일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-13.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_09.mp3"),
        buttons: [
          { ch2: "Jīntiān sān yuè wǔ hào." },
          { ch: "今天三月五号。" },
          { ko: "오늘은 3월 5일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-10.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_10.mp3"),
        buttons: [
          { ch2: "Jīntiān sì yuè èrshí hào." },
          { ch: "今天四月二十号。" },
          { ko: "오늘은 4월 20일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-11.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_11.mp3"),
        buttons: [
          { ch2: "Jīntiān wǔ yuè èrshíyī hào." },
          { ch: "今天五月二十一号。" },
          { ko: "오늘은 5월 21일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-08.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_12.mp3"),
        buttons: [
          { ch2: "Jīntiān liù yuè èrshí'èr hào." },
          { ch: "今天六月二十二号。" },
          { ko: "오늘은 6월 22일이야." },
        ],
      },
      {
        img: require("@data/assets/green/book12/images/img_G12-09.png"),
        sound: require("@data/assets/green/book12/sounds/KD12_W_13.mp3"),
        buttons: [
          { ch2: "Jīntiān qī yuè sānshí hào." },
          { ch: "今天七月三十号。" },
          { ko: "오늘은 7월 30일이야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/green/book12/sounds/KD12_W_02.mp3"),
          img: require("@data/assets/green/book12/images/img_G12-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/green/book12/sounds/KD12_W_05.mp3"),
          answer: [
            [require("@data/assets/green/book12/images/img_G12-04.png"), true],
            [require("@data/assets/green/book12/images/img_G12-02.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/green/book12/sounds/KD12_W_03.mp3"),
          answer: [
            ["四月二十号", true],
            ["七月三十号", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/green/book12/pages/front.jpg"),
        sound: require("@data/assets/green/book12/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/green/book12/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page04.jpg"),
        sound: require("@data/assets/green/book12/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page06.jpg"),
        sound: require("@data/assets/green/book12/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page08.jpg"),
        sound: require("@data/assets/green/book12/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page10.jpg"),
        sound: require("@data/assets/green/book12/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page12.jpg"),
        sound: require("@data/assets/green/book12/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page14.jpg"),
        sound: require("@data/assets/green/book12/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page16.jpg"),
        sound: require("@data/assets/green/book12/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page18.jpg"),
        sound: require("@data/assets/green/book12/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page20.jpg"),
        sound: require("@data/assets/green/book12/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page22.jpg"),
        sound: require("@data/assets/green/book12/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page23.jpg"),
        sound: require("@data/assets/green/book12/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/green/book12/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/green/book12/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/green/book12/thumbnail/front.jpg"),
      require("@data/assets/green/book12/thumbnail/page02.jpg"),
      require("@data/assets/green/book12/thumbnail/page03.jpg"),
      require("@data/assets/green/book12/thumbnail/page04.jpg"),
      require("@data/assets/green/book12/thumbnail/page05.jpg"),
      require("@data/assets/green/book12/thumbnail/page06.jpg"),
      require("@data/assets/green/book12/thumbnail/page07.jpg"),
      require("@data/assets/green/book12/thumbnail/page08.jpg"),
      require("@data/assets/green/book12/thumbnail/page09.jpg"),
      require("@data/assets/green/book12/thumbnail/page10.jpg"),
      require("@data/assets/green/book12/thumbnail/page11.jpg"),
      require("@data/assets/green/book12/thumbnail/page12.jpg"),
      require("@data/assets/green/book12/thumbnail/page13.jpg"),
      require("@data/assets/green/book12/thumbnail/page14.jpg"),
      require("@data/assets/green/book12/thumbnail/page15.jpg"),
      require("@data/assets/green/book12/thumbnail/page16.jpg"),
      require("@data/assets/green/book12/thumbnail/page17.jpg"),
      require("@data/assets/green/book12/thumbnail/page18.jpg"),
      require("@data/assets/green/book12/thumbnail/page19.jpg"),
      require("@data/assets/green/book12/thumbnail/page20.jpg"),
      require("@data/assets/green/book12/thumbnail/page21.jpg"),
      require("@data/assets/green/book12/thumbnail/page22.jpg"),
      require("@data/assets/green/book12/thumbnail/page23.jpg"),
      require("@data/assets/green/book12/thumbnail/page24.jpg"),
      require("@data/assets/green/book12/thumbnail/page25.jpg"),
      require("@data/assets/green/book12/thumbnail/page26.jpg"),
      require("@data/assets/green/book12/thumbnail/page27.jpg"),
    ],
  },
];
